import { StackProps, VStack } from "@chakra-ui/react";

export function FunnelStepContainer(props: StackProps) {
  return <VStack gap={4} alignItems={"stretch"} {...props} />;
}
